import React, { useEffect, useState } from "react";
import { auth, db } from "../firebaseConfig";
import { doc, getDoc } from "firebase/firestore";
import PaySubscription from "./PaySubscription";
import "../styles/Billing.css";

const BillingOverview = () => {
  const [tier, setTier] = useState("loading...");
  const [daysLeft, setDaysLeft] = useState(null);
  const [subscriptionEnd, setSubscriptionEnd] = useState(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const fetchBilling = async () => {
      const user = auth.currentUser;
      if (!user) return;

      const userRef = doc(db, "users", user.uid);
      const docSnap = await getDoc(userRef);

      if (docSnap.exists()) {
        const data = docSnap.data();
        setTier(data.tier || "basic");

        if (data.subscriptionEnd) {
          const endDate = new Date(data.subscriptionEnd);
          const now = new Date();
          const diffDays = Math.ceil((endDate - now) / (1000 * 60 * 60 * 24));
          setDaysLeft(diffDays);
          setSubscriptionEnd(endDate.toDateString());
        }
      } else {
        setTier("basic");
      }
    };

    fetchBilling();
  }, []);

  return (
    <>
      <button className="btn billing-toggle" onClick={() => setVisible(true)}>
        💳 Billing Info
      </button>

      {visible && (
        <div className="billing-modal">
          <div className="billing-card">
            <div className="billing-header">
              <h2>📄 Billing Overview</h2>
              <button className="close-btn" onClick={() => setVisible(false)}>✖</button>
            </div>

            <p><strong>Tier:</strong> {tier.charAt(0).toUpperCase() + tier.slice(1)}</p>
            {subscriptionEnd ? (
              <>
                <p><strong>Subscription Ends:</strong> {subscriptionEnd}</p>
                <p><strong>Days Remaining:</strong> {daysLeft} day(s)</p>
              </>
            ) : (
              <p><em>No active subscription</em></p>
            )}

            <hr style={{ margin: "16px 0", borderColor: "#334155" }} />
            <PaySubscription />
          </div>
        </div>
      )}
    </>
  );
};

export default BillingOverview;
